import { I as Icon, _ as _extends } from './Icon-465858dc.js';
import React, { forwardRef } from 'react';
import '@emotion/is-prop-valid';
import '@indeed/ifl-css';
import '@emotion/react';
import './IconProvider.js';

const Twitter = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    fill = "currentColor",
    size = "md",
    variant,
    ...remainingProps
  } = _ref;
  const paths = {
    filled: /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      d: "M21.8883 5.693a.4158.4158 0 00-.4983-.085c-.1192.0625-.3509.1441-.6225.2241.3258-.4275.59-.9133.7033-1.3483a.4173.4173 0 00-.1658-.4483.419.419 0 00-.4784.0033c-.245.1742-1.3775.6758-2.1083.8383-.9275-.8341-1.8508-1.2091-2.9675-1.2091-.8375 0-1.6133.2391-2.515.7741-1.5725.9334-1.845 2.9509-1.7283 4.1884-4.2684-.4067-6.6625-2.89-7.5134-3.9709-.085-.1075-.22-.1591-.3566-.1575a.417.417 0 00-.3309.2059c-1.0175 1.7441-.6008 3.5391.1809 4.7466a5.2613 5.2613 0 01-.3884-.2925c-.125-.1025-.2975-.1258-.4433-.0558a.4157.4157 0 00-.2392.3767c0 1.8308 1.0725 3.1391 2.1192 3.8825a7.6486 7.6486 0 01-.3283-.0959c-.1567-.0475-.3267-.0016-.435.1209a.4164.4164 0 00-.07.4466c.6691 1.5042 2 2.6259 3.4916 3.0159-1.2825.7808-3.0558 1.1816-4.7291.9841-.195-.0258-.3825.0959-.4442.2842a.4172.4172 0 00.1892.4917c2.0283 1.1583 4.1358 1.7216 6.4425 1.7216h.015c3.1508-.0025 6.11-1.3733 8.3316-3.86 2.1442-2.3991 3.2684-5.4716 3.0384-8.2691.5508-.4117 1.385-1.1817 1.8991-2.0084.1-.16.08-.3666-.0483-.5041z",
      clipRule: "evenodd"
    }),
    stroke: /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      d: "M21.8883 5.693a.4158.4158 0 00-.4983-.085c-.1192.0625-.3509.1441-.6225.2241.3258-.4275.59-.9133.7033-1.3483a.4173.4173 0 00-.1658-.4483.419.419 0 00-.4784.0033c-.245.1742-1.3775.6758-2.1083.8383-.9275-.8341-1.8508-1.2091-2.9675-1.2091-.8375 0-1.6133.2391-2.515.7741-1.5725.9334-1.845 2.9509-1.7283 4.1884-4.2684-.4067-6.6625-2.89-7.5134-3.9709-.085-.1075-.22-.1591-.3566-.1575a.417.417 0 00-.3309.2059c-1.0175 1.7441-.6008 3.5391.1809 4.7466a5.2613 5.2613 0 01-.3884-.2925c-.125-.1025-.2975-.1258-.4433-.0558a.4157.4157 0 00-.2392.3767c0 1.8308 1.0725 3.1391 2.1192 3.8825a7.6486 7.6486 0 01-.3283-.0959c-.1567-.0475-.3267-.0016-.435.1209a.4164.4164 0 00-.07.4466c.6691 1.5042 2 2.6259 3.4916 3.0159-1.2825.7808-3.0558 1.1816-4.7291.9841-.195-.0258-.3825.0959-.4442.2842a.4172.4172 0 00.1892.4917c2.0283 1.1583 4.1358 1.7216 6.4425 1.7216h.015c3.1508-.0025 6.11-1.3733 8.3316-3.86 2.1442-2.3991 3.2684-5.4716 3.0384-8.2691.5508-.4117 1.385-1.1817 1.8991-2.0084.1-.16.08-.3666-.0483-.5041z",
      clipRule: "evenodd"
    })
  };
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref,
    fill: fill,
    paths: paths,
    size: size,
    variant: variant
  }, remainingProps));
});
Twitter.displayName = "TwitterIcon";

export { Twitter, Twitter as default };
